import React, { useState, useEffect } from 'react';
import Loader from "react-loader-spinner";
import { MdClose } from 'react-icons/md';
import * as jobsActions from '../../Redux/Actions/jobs';
import { toastMessage } from '../../utils/toast'

const UpdateDeliveryModal = ({ t, showModal, loading, statusOptions, handleCancel, referenceEditData, handleOk, footerOption1, footerOption2 }) => {
 
    const [refNumber, setRefNumber] = useState('');
    const [emiratePostReferenceNumber, setEmiratePostReferenceNumber] = useState('');
    const [buttonLoading, setButtonLoading] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState('');

    useEffect(()=> {
        setRefNumber(referenceEditData && referenceEditData.referenceNumber);
        setEmiratePostReferenceNumber(referenceEditData && referenceEditData.emiratePostReferenceNumber);
        setSelectedStatus(referenceEditData && referenceEditData.status);
    }, [referenceEditData]);

    const updateHandler = () => {
        setButtonLoading(true);
            jobsActions.updateDeliveryRequest(refNumber, selectedStatus, emiratePostReferenceNumber).then(res => {
                if(res && res.data){
                   toastMessage('success', 'Delivery request updated successfully.');
                   setButtonLoading(false);
                   handleCancel();
                   window.location.reload();  
                }else{
                    setButtonLoading(false);
                    toastMessage('error', (res && res.message) || 'Try again later');
                }
            }).catch(err => {
                setButtonLoading(false);
                toastMessage('error', (err && err.message) || 'Try again later');
            });
    }

    return(
        <div>
            <div className="modal" style={{display: (showModal ? 'block': '')}}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{t("deliveryManagement.manageDelivery.updateDeliveryRequest")}</h5>
                            <button type="button" className="close" aria-label="Close" onClick={handleCancel} style={{border: 'none'}}>
                                <MdClose />
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="d-flex flex-column mb-2">
                                <label className="form-label mb-1">{t("deliveryManagement.manageDelivery.refNo")}: {referenceEditData.referenceNumber}</label>
                                <label className="form-label mb-1">{t("jobsManagement.manageJobs.id")}: {referenceEditData.jobId}</label>
                                <label className="form-label mb-1">{t("deliveryManagement.manageDelivery.deliveryType")}: {referenceEditData.type}</label>
                                <label className="form-label mb-1">{t("deliveryManagement.manageDelivery.documents")}: {referenceEditData.documents ? referenceEditData.documents : '-'}</label>
                            </div>
                            <div className="d-flex flex-column mb-2">
                                <label className="form-label mb-1">{t("deliveryManagement.manageDelivery.status")}</label><select className="form-select me-3" value={selectedStatus}  onChange={e => setSelectedStatus(e.target.value)}>
                                    <option value="" disabled={true}>{t("jobsManagement.filters.selectJobStatus")}</option>
                                    {statusOptions.map((option) => (<option key={option.value} value={option.value}>{option.lable}</option>))}
                                </select>
                            </div>
                            <div className="d-flex flex-column mb-2">
                                <label className="form-label mb-1">{t("deliveryManagement.manageDelivery.emiratePostReferenceNumber")}</label>
                                <input placeholder={emiratePostReferenceNumber} type="text" className="form-control me-3" name="Filter ID" value={emiratePostReferenceNumber} onChange={e => setEmiratePostReferenceNumber(e.target.value)}  />
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-light-danger font-weight-bold" onClick={handleCancel}> {footerOption2 ? footerOption2 :t("Close")} </button>
                            <button type="button" className="btn btn-primary font-weight-bold d-flex align-items-center" disabled={loading || buttonLoading} onClick={()=> {updateHandler()}}>
                                {footerOption1 ? footerOption1 :t("jobsManagement.infoJob.createDeliveryRequest.update")} {(loading || buttonLoading) && <Loader type="Oval" color="#fff" height={20} width={20} style={{marginLeft: '10px'}} />}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop show"></div>
        </div>
    );
};

export default UpdateDeliveryModal;
